$(document).ready(function() {
   // quantity increment decrement code start
   $(".table__checkout__body--qty").on('click','.quantity__trigger',function(){
   $input = $(this).siblings(".quantity__value");
    if ($(this).hasClass('quantity__increment'))
      $input.val(parseInt($input.val())+1);
    else if(parseInt($input.val())>0)
      $input.val(parseInt($input.val())-1);
    });

   // slider code start
    var owl = $(".product-slider");
    owl.owlCarousel({
     items: 1,
     nav:true,
     arrows:true
   });
  
   // customise thumnail section start
  
  var bigimage = $("#big");
  var thumbs = $("#thumbs");
  //var totalslides = 10;
  var syncedSecondary = true;

  bigimage
    .owlCarousel({
    items: 1,
    nav: false,
    dots: false,
    loop: true
   })
    .on("changed.owl.carousel", syncPosition);

  thumbs
    .on("initialized.owl.carousel", function() {
    thumbs
      .find(".owl-item")
      .eq(0)
      .addClass("current");
  })
    .owlCarousel({
    dots: false,
    nav: true,
    margin:10,
   responsive : {
    0 : {
      items:2,
      slideBy: 2,
      
    },
    768 : {
      items:4,
      slideBy: 4,
    },
     1024 : {
      items:5,
      slideBy:5
    },
     1200 : {
      items:7,
      slideBy:7,
      margin:20
    }
  }
})
    .on("changed.owl.carousel", syncPosition2);

 
  
  function syncPosition(el) {
    //if loop is set to false, then you have to uncomment the next line
    //var current = el.item.index;

    //to disable loop, comment this block
    var count = el.item.count - 1;
    var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

    if (current < 0) {
      current = count;
    }
    if (current > count) {
      current = 0;
    }
    //to this
    thumbs
      .find(".owl-item")
      .removeClass("current")
      .eq(current)
      .addClass("current");
    var onscreen = thumbs.find(".owl-item.active").length - 1;
    var start = thumbs
    .find(".owl-item.active")
    .first()
    .index();
    var end = thumbs
    .find(".owl-item.active")
    .last()
    .index();

    if (current > end) {
      thumbs.data("owl.carousel").to(current, 100, true);
    }
    if (current < start) {
      thumbs.data("owl.carousel").to(current - onscreen, 100, true);
    }
  }

  function syncPosition2(el) {
    if (syncedSecondary) {
      var number = el.item.index;
      bigimage.data("owl.carousel").to(number, 100, true);
    }
  }

  thumbs.on("click", ".owl-item", function(e) {
    e.preventDefault();
    var number = $(this).index();
    bigimage.data("owl.carousel").to(number, 300, true);
  });
  // customise thumnail section end

  
  // customise 2 thumnail section start
  
  var bigimage2 = $("#big2");
  var thumbs2 = $("#thumbs2");
  //var totalslides = 10;
  var syncedSecondary = true;

  bigimage2
    .owlCarousel({
    items: 1,
    nav: false,
    dots: false,
    loop: true
   })
    .on("changed.owl.carousel", syncPosition);

  thumbs2
    .on("initialized.owl.carousel", function() {
    thumbs2
      .find(".owl-item")
      .eq(0)
      .addClass("current");
  })
    .owlCarousel({
    dots: false,
    nav: true,
    margin:10,
   responsive : {
    0 : {
      items:2,
      slideBy: 2,
      
    },
    768 : {
      items:4,
      slideBy: 4,
    },
     1024 : {
      items:5,
      slideBy:5
    },
     1200 : {
      items:7,
      slideBy:7,
      margin:20
    }
  }
})
    .on("changed.owl.carousel", syncPosition2);
  
  function syncPosition(el) {
    //if loop is set to false, then you have to uncomment the next line
    //var current = el.item.index;

    //to disable loop, comment this block
    var count = el.item.count - 1;
    var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

    if (current < 0) {
      current = count;
    }
    if (current > count) {
      current = 0;
    }
    //to this
    thumbs2
      .find(".owl-item")
      .removeClass("current")
      .eq(current)
      .addClass("current");
    var onscreen = thumbs2.find(".owl-item.active").length - 1;
    var start = thumbs2
    .find(".owl-item.active")
    .first()
    .index();
    var end = thumbs2
    .find(".owl-item.active")
    .last()
    .index();

    if (current > end) {
      thumbs2.data("owl.carousel").to(current, 100, true);
    }
    if (current < start) {
      thumbs2.data("owl.carousel").to(current - onscreen, 100, true);
    }
  }

  function syncPosition2(el) {
    if (syncedSecondary) {
      var number = el.item.index;
      bigimage2.data("owl.carousel").to(number, 100, true);
    }
  }

  thumbs2.on("click", ".owl-item", function(e) {
    e.preventDefault();
    var number = $(this).index();
    bigimage2.data("owl.carousel").to(number, 300, true);
  });



  
  // end for second slider
});
